import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import TradingBotHero from "./TradingBotHero";
import Backtesting from "./Backtesting";
import DeliverBestCryBot from "./DeliverBestCryBot";
import BotAlgorithm from "./BotAlgorithm";
import AutomateYourTrading from "./AutomateYourTrading";
import WhyChooseXeer from "../../DeFi/DeFiStaking/WhyChooseXeer";

function TradingBot() {
  return (
    <div>
      <Header />
      <TradingBotHero />
      <Backtesting />
      <DeliverBestCryBot />
      <BotAlgorithm />
      <AutomateYourTrading />
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default TradingBot;
